import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h3", { class: "text-[34px] h-11 leading-11 font-bold mb-4" }, "События СКУД", -1)

import { usePermissions } from "@/use/usePermissions";

import UiApp from "@/plugins/ui/components/app/UiApp.vue";

import UiPlaceholder from "@/plugins/ui/components/placeholder/UiPlaceholder.vue";

import AppTabbar from "@/components/AppTabbar.vue";
import AppSidebar from "@/components/AppSidebar.vue";
import FullAcsEvents from "@/components/acs-events/FullAcsEvents.vue";
import UiAppbar from "@/plugins/ui/components/appbar/UiAppbar.vue";
import UiIconBtn from "@/components/ui/UiIconBtn.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'AcsEvents',
  setup(__props) {

const { isAllow } = usePermissions();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(UiApp, null, {
    header: _withCtx(() => [
      _createVNode(UiAppbar, {
        temporary: "",
        title: "События СКУД"
      }, {
        right: _withCtx(() => [
          _createVNode(UiIconBtn, {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.replace('/settings'))),
            variant: "tertiary",
            icon: "Cog"
          })
        ]),
        _: 1
      })
    ]),
    footer: _withCtx(() => [
      _createVNode(AppTabbar)
    ]),
    sidebar: _withCtx(() => [
      _createVNode(AppSidebar)
    ]),
    default: _withCtx(() => [
      _hoisted_1,
      (_unref(isAllow)('acs'))
        ? (_openBlock(), _createBlock(FullAcsEvents, { key: 0 }))
        : (_openBlock(), _createBlock(UiPlaceholder, {
            key: 1,
            icon: "LockClosed",
            title: "Модуль «События СКУД» недоступен",
            description: "К сожалению, модуль «События СКУД» не подключен к вашей школе."
          }))
    ]),
    _: 1
  }))
}
}

})